module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = 404
// module chunks = 273950069227526